import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios';
import { t_machine, newEquipment } from '../types';

class MachineService {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  getDataStoreFieldMachine(params: { appId: string; dataStoreId: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/${params.dataStoreId}/fields`,
    };
    return this.axios(request);
  }

  getDataStoreFieldEquipment(params: { appId: string; dataStoreId: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/${params.dataStoreId}/fields`,
    };
    return this.axios(request);
  }

  newItemMachine(data: t_machine): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_machine/items/new`,
      data: {
        item: data,
        return_item_result: true,
      },
    };
    return this.axios(request);
  }

  newEquipment(data: newEquipment): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_equipment_lease/items/new`,
      data: {
        item: data.item,
        return_item_result: true,
        related_ds_items: {
          t_machine: data.related_ds_items,
        },
        is_sync_related_items: true,
      },
    };
    return this.axios(request);
  }

  updateEquiment(data: newEquipment): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_equipment_lease/items/edit/${data.item.i_id}`,
      data: {
        item_id: data.item.i_id,
        item: data.item,
        return_item_result: true,
        related_ds_items: {
          t_machine: data.related_ds_items,
        },
        is_force_update: true,
        is_sync_related_items: true,
      },
    };
    return this.axios(request);
  }
  endLease(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_equipment_lease/items/action/${data.item.i_id}/end_the_contract`,
      data: {
        item: data.item,
        return_item_result: true,
        related_ds_items: {
          t_machine: data.related_ds_items,
        },
        is_force_update: true,
        access_key_updates: {
          overwrite: true,
          apply_related_ds: true,
        },
      },
    };
    return this.axios(request);
  }
  listPatient(data: string): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/reports/machine_rental_status/filter`,
      data: {
        conditions: [
          {
            id: 'lease_contract_id',
            search_value: [data],
          },
        ],
        per_page: 0,
      },
    };
    return this.axios(request);
  }
  changeStatusItem(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_machine/items/bulkaction/Return_the_machine`,
      data: {
        conditions: [
          {
            id: 'i_id',
            search_value: data,
          },
        ],
        item: {},
        item_revisions: {},
        comment: 'リース機器個別返却',
        max_items: 300,
        use_display_id: true,
        continue_proc: true,
      },
    };
    return this.axios(request);
  }
  changeStatusBackItem(data: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_machine/items/bulkaction/Back_the_machine`,
      data: {
        conditions: [
          {
            id: 'i_id',
            search_value: data,
          },
        ],
        item: {},
        item_revisions: {},
        comment: 'リース中に戻す',
        max_items: 300,
        use_display_id: true,
        continue_proc: true,
      },
    };
    return this.axios(request);
  }
  deleteMachine(itemID: string): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      url: `applications/CPAP/datastores/t_machine/items/delete/${itemID}`,
      method: 'DELETE',
      data: {},
    };
    return this.axios(request);
  }
  deleteEquiment(itemID: string): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      url: `applications/CPAP/datastores/t_equipment_lease/items/delete/${itemID}`,
      method: 'DELETE',
      data: {
        delete_linked_items: true,
        target_datastores: ['t_machine'],
      },
    };
    return this.axios(request);
  }
}

export default MachineService;
